import type { FetchMonthlyExpiryCalendarsDatesEpicApi } from 'epic/common-form/fetchMonthlyExpiryCalendarsDatesEpic';
import type { FetchSettlementCalendarsBlackoutDatesEpicApi } from 'epic/common-form/fetchSettlementCalendarsBlackoutDatesEpic';
import type {
  BdrValuationCalendarsBlackoutDatesMap,
  FetchValuationCalendarsBlackoutDatesEpicApi,
} from 'epic/common-form/fetchValuationCalendarsBlackoutDatesEpic';
import { map } from 'rxjs/operators';
import type { BdrMonthlyExpiryDatesState } from 'state/monthlyExpiryDates/monthlyExpiryDates.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

type BdrCalendarsApi = FetchValuationCalendarsBlackoutDatesEpicApi &
  FetchSettlementCalendarsBlackoutDatesEpicApi &
  FetchMonthlyExpiryCalendarsDatesEpicApi;

export function bdrCalendarsApiConnector(httpClient: IHttpClient): BdrCalendarsApi {
  return {
    getValuationCalendarsBlackoutDates(calendarCodes) {
      return httpClient
        .postJSON<BdrValuationCalendarsBlackoutDatesMap>({
          url: 'api/v1/valuation-calendars/blackoutDates',
          body: calendarCodes,
        })
        .pipe(map(({ payload }) => payload));
    },
    getSettlementCalendarsBlackoutDates(currencyCode) {
      return httpClient
        .getJSON<string[]>({
          url: 'api/v1/settlement-calendars/blackoutDates',
          params: {
            currencyCode,
          },
        })
        .pipe(map(({ payload }) => payload));
    },
    getMonthlyExpiryCalendarsDates(calendarCodes) {
      return httpClient
        .postJSON<BdrMonthlyExpiryDatesState>({
          url: 'api/v1/monthly-calendars/expiryDates',
          body: calendarCodes,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
